import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'
import Sortable from 'sortablejs'

// Connects to data-controller="application--sortable"
export default class extends Controller {
  static targets = ['counter', 'handle']
  static values = {
    draggable: { type: String, default: '.item' }, // ".item" is the default value
    group: { type: String, default: 'name' }, // "name" is the default value
    disabled: { type: Boolean, default: true }, // disabled by default
    paramKey: { type: String, default: 'test_script_step' }, // wraps the position param in the PATCH body
    handle: { type: String, default: '' } // optional selector restricting where a drag can start
  }

  connect () {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      disabled: this.disabledValue,
      draggable: this.draggableValue,
      group: this.groupValue,
      handle: this.handleValue || undefined,
      onEnd: this.end.bind(this)
    })
    this.reorderButtonElements.forEach((button) => {
      button.addEventListener('click', this.toggleState.bind(this))
    })
  }

  // Announces the drop once the new order is saved, for anything on the page
  // that wants to know a reorder happened rather than how.
  end (event) {
    patch(event.item.dataset.url, {
      body: {
        [this.paramKeyValue]: {
          position: event.newIndex + 1
        }
      }
    }).then(() => this.dispatch('reordered'))
  }

  toggleState () {
    this.disabledValue = !this.disabledValue
    // Toggle 'data-turbo-permanent' attribute on the closest section element
    const section = this.element.closest('section')
    if (section) {
      section.toggleAttribute('data-turbo-permanent')
    }
    this.sortable.option('disabled', this.disabledValue)
    // Loop over each counter target and update the value to its index + 1
    if (this.hasCounterTarget) {
      this.counterTargets.forEach((counter, index) => {
        counter.textContent = index + 1
      })
    }
    // Toggle between showing the value and the handle
    if (this.hasHandleTarget) {
      this.handleTargets.forEach(handle => handle.classList.toggle('hidden'))
    }
    // If we have any reorderButtonElements, toggle them
    if (this.reorderButtonElements) {
      this.reorderButtonElements.forEach(
        (button) => button.classList.toggle('hidden'))
    }
  }

  get reorderButtonElements () {
    return document.querySelectorAll('.reorder-button')
  }
}
